export default "__VITE_ASSET__CYdSpnK$__"